import { useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";

import { queryClient } from "App";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import { getNextQueryParams } from "components/helpers";
import RuvixxDate from "components/RuvixxDate";
import useMetaSyncInProgress, {
  META_SYNC_POLL_INTERVAL_MS,
} from "hooks/useMetaSyncInProgress";
import MetaPixelStatService from "services/MetaPixelStat";

const eventsQueryKey = accountId => ["meta-pixel-stats", accountId];

const EVENT_COLUMNS = [
  {
    header: "ID",
    id: "ID",
    accessorKey: "id",
    size: 50,
    cell: ({ row }) => (
      <p style={{ fontWeight: "bold" }}>{row.getValue("ID")}</p>
    ),
  },
  { id: "Event", accessorKey: "event", header: "Event", size: 200 },
  { id: "Pixel", accessorKey: "pixel_id", header: "Pixel", size: 200 },
  {
    id: "Date",
    accessorKey: "bucket_start",
    header: "Date",
    size: 160,
    enableSorting: true,
    cell: ({ row }) => {
      const date = row.getValue("Date");
      return date ? <RuvixxDate date={date} /> : null;
    },
  },
  { id: "Count", accessorKey: "count", header: "Count", size: 120 },
];

const MetaEventsTab = () => {
  const { accountId } = useParams();

  const columns = useMemo(() => EVENT_COLUMNS, []);
  const isSyncing = useMetaSyncInProgress(accountId, "live");

  const invalidateEvents = useCallback(
    () =>
      queryClient.invalidateQueries({ queryKey: eventsQueryKey(accountId) }),
    [accountId]
  );

  const fetchEvents = useCallback(
    async queryParams => {
      const next = getNextQueryParams(queryParams, columns);
      return MetaPixelStatService.list(accountId, next);
    },
    [accountId, columns]
  );

  return (
    <div className="tw:flex tw:min-h-0 tw:min-w-0 tw:flex-1 tw:flex-col">
      <BaseTableV3
        columns={columns}
        header="Events"
        tableName="meta_pixel_stats"
        queryKey={eventsQueryKey(accountId)}
        fetchData={fetchEvents}
        invalidateData={invalidateEvents}
        refetchInterval={isSyncing ? META_SYNC_POLL_INTERVAL_MS : undefined}
        enableSearch
        enableSettings
      />
    </div>
  );
};

export default MetaEventsTab;
